import { render, staticRenderFns } from "./Relate.vue?vue&type=template&id=6c60c302&scoped=true&"
import script from "./Relate.vue?vue&type=script&lang=js&"
export * from "./Relate.vue?vue&type=script&lang=js&"
import style0 from "./Relate.vue?vue&type=style&index=0&id=6c60c302&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../rebuild/yeh/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c60c302",
  null
  
)

export default component.exports